<template>
    <div class="toplogo-container">
        <div class="fixed-toplogo" :class="white?'white':'color'">
            <img src="../assets/logo-color-inline.svg" :class="plain?'':'mb'"
                 v-if="!white" class="top-logo" alt="Li.Re.">
            <img src="../assets/logo-white-inline.svg" :class="plain?'':'mb'"
                 v-else class="top-logo" alt="Li.Re.">
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'white', 'plain'
        ]
    }
</script>

<style scoped lang="scss">
    .toplogo-container {
        margin-bottom: 40px;
    }

    .fixed-toplogo {
        margin-top: -20px;
        margin-left: -20px;
        padding-top: 20px;
        padding-bottom: 20px;
        position: fixed;
        width: 100%;

        max-height: 60px;

        &.color {
            background: #fff;
        }
    }
    .top-logo {
        display: block;

        &.mb {
            margin: 0 auto 20px;
        }

        &:not(.mb) {
            margin: 0 auto;
        }

        width: 30%;
        max-width: 120px;
    }
</style>
